import {decorate, inject, injectable} from '@yosmanyga/di';
import {AxiosInstance} from './Axios';

class HelpApi {
    constructor(private axios: AxiosInstance) {
    }

    get = async () => {
        const {data}: {data: HelpType} = await this.axios
            .withLanguage()
            .get('/v1/get-help');

        return data;
    };
}

type HelpType = {
    intro: string,
    gameplay: string,
    cheatsheet: string,
    credits: string,
}

decorate(injectable(), HelpApi);
decorate(inject(AxiosInstance), HelpApi, 0);

export type {
    HelpType
};

export {
    HelpApi
};
